// Native types
export const CHAT_REPLY_TYPE = 'chat_member_reply'
export const CANCEL_APPOINTMENT_TYPE = 'appointment_canceled'
export const ASSIGNED_TYPE = 'ticket_assigned'
export const ALARM_TYPE = 'ticket_alarm'
export const TASK_TYPE = 'due_task'
export const TASK_ASSIGNED_TYPE = 'task_assigned'
export const USER_TAGGED = 'user_tagged'

export const BULK_UPLOAD_CATEGORIES_TYPE = 'upload_plan_categories'
export const INSURANCE_PLAN_BULK_UPLOAD = 'insurance_plan_bulk_upload'
export const BULK_CREATE_TICKETS = 'bulk_create_tickets'

export const BENEFIT_CATEGORIES_BULK_CREATE = 'benefit_categories_created'
export const BENEFIT_GROUPS_BULK_CREATE = 'benefit_groups_bulk_created'
export const BENEFITS_BULK_CREATE = 'benefits_bulk_created'
export const INSURANCE_PLAN_CLONED = 'insurance_plan_cloned'
export const INTERACTIONS_BULK_CREATE = 'interactions_bulk_create'
export const TICKET_DELIVERABLES_BULK_CREATE = 'ticket_deliverables_bulk_create'
export const TICKET_BULK_ASSIGN_TO_PERFORMER =
  'bulk_assign_tickets_to_performer'
export const TICKET_BULK_ASSIGN_TO_QUEUE = 'bulk_assigned_tickets_to_queue'
export const TICKET_BULK_ASSIGN_TO_RECIPIENT =
  'bulk_assign_tickets_to_recipient'
export const TICKET_BULK_CHANGE_STATUS = 'bulk_change_status_tickets'
export const BENEFIT_ORGS_BULK_UPLOAD = 'insurance_plan_add_availability'

// Synthetic types
export const GROUPED_REPLY_TYPE = 'grouped_reply'

export const ALARMS = 'alarms'
export const NOTIFICATIONS = 'notifications'

// Styles
export const APPOINTMENT_RED = '#DB5753'
export const ASSIGNMENT_GRAY = '#111827'
export const ALARM_ORANGE = '#E49300'
export const MESSAGE_BLUE = '#4085F1'
export const TASK_BLACK = 'black'

export const BULK_UPLOAD_CATEGORIES_TYPE_ERRORS = {
  malformed_csv: 'Please upload the file in CSV format',
  server_error: 'Something went wrong: Failed to bulk upload (Frontend)',
  required_column_missing_error:
    'Make sure all required columns presented in the document',
  required_field_missing_error: 'Make sure all required fields have value',
  exists_categories_error: 'Some categories already exists',
  tiers_missing_error:
    'Tier Name not found, please check the plan tiers in the file and try again.',
  not_exists_column: 'Make sure all required columns presented in the document'
}

export const INSURANCE_PLAN_CLONED_ERRORS = {
  insurance_plan_clone_failed: 'Failed to clone plan'
}

export const BENEFIT_CATEGORIES_BULK_CREATE_ERRORS = {
  benefit_categories_bulk_created: 'Benefit category creation failed',
  benefit_categories_bulk_created_conflict:
    'Benefits category creation failed. Category with such name already exists'
}

export const BENEFIT_GROUPS_BULK_CREATE_ERRORS = {
  benefit_groups_bulk_created: 'Benefits creation failed.',
  benefit_groups_bulk_created_conflict:
    'Benefits creation failed. Benefit with such name already exists'
}

export const BENEFITS_BULK_CREATE_ERRORS = {
  benefits_bulk_created: 'Tier creation failed',
  benefits_bulk_created_conflict:
    'Tier creation failed. Benefit with such name already exists'
}

export const INSURANCE_PLAN_BULK_UPLOAD_ERRORS = {
  aws_error:
    'Something went wrong: Failed to bulk upload. Issue with AWS (Frontend)',
  malformed_csv: 'Please upload the file in CSV format',
  headers_missing:
    'Please ensure all required columns presented in the document',
  validation_failed:
    'Please ensure all required fields are filled out and upload the file again'
}

export const TICKET_DELIVERABLES_BULK_CREATE_ERRORS = {
  server_error:
    'Failed to add deliverables to tickets. Please ensure you are not overwriting existing values.'
}
